export default (params, { prefix = '?' } = {}) => {
  return (
    prefix +
    Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&')
  )
}
